import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { MatomoProvider, createInstance } from 'react-matomo';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  "a7b3986d266ef1d957081f37760a6550Tz0xMzE2OTUsRT0xODE3NDIzOTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=" // Get this from your MUI account dashboard
);

const matomoUrl = 'https://prospectsavant.matomo.cloud/'; // Replace with your URL
const siteId = 1; // Replace with your Site ID

const matomoInstance = createInstance({
  url: matomoUrl,
  siteId: siteId,
});


const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <MatomoProvider value={matomoInstance}>
      <App />
    </MatomoProvider>
  </React.StrictMode>
);
